import React, { Component } from "react";
import Table from "./components/Table";
import { Card, CardTitle } from "reactstrap";

class TablesData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: props.columns,
      data: props.data,
      title: props.title,
    };
  }

  componentDidMount = () => {
    this.setState({
      columns: this.props.columns,
      data: this.props.data,
      title: this.props.title,
    });
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      columns: nextProps.columns,
      data: nextProps.data,
      title: nextProps.title,
    });
  };

  render() {
    const { columns, data, title } = this.state;
    return (

      <Card body>
        <CardTitle>
          <legend className="titleCardResumen">{title}</legend>
        </CardTitle>
        <Table
          columns={columns}
          data={data}
          options={{
            large: false,
            downloads: {
              pdf: false,
              xlsx: false,
            },
          }}
        />
      </Card>

    );
  }
}

export default TablesData;
